/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Title_DraftInputs */

const en_us2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap in the draft`)
};

const pt_br2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar no rascunho`)
};

const es_419_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar en el borrador`)
};

const pt_pt2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar no rascunho`)
};

const fr_fr2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer dans le brouillon`)
};

const de_de2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Entwurf tauschen`)
};

const it_it2_swap_title_draft = /** @type {(inputs: Swap_Title_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia nella bozza`)
};

/**
* | output |
* | --- |
* | "Swap in the draft" |
*
* @param {Swap_Title_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_title_draft = /** @type {((inputs?: Swap_Title_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Title_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_title_draft(inputs)
	if (locale === "es-419") return es_419_swap_title_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_title_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_title_draft(inputs)
	if (locale === "de-DE") return de_de2_swap_title_draft(inputs)
	if (locale === "it-IT") return it_it2_swap_title_draft(inputs)
	return en_us2_swap_title_draft(inputs)
});
export { swap_title_draft as "swap.title_draft" }